class ProductModal extends ModalDialog {
  constructor() {
    super();
    this.slider = null;
    this.thumbsSlider = null;
  }

  initSliders() {
    if (this.slider) return;

    const thumbsEl = this.querySelector('[data-gallery-thumbs]');

    if (thumbsEl) {
      this.thumbsSlider = new Swiper(thumbsEl, {
        slidesPerView: 'auto',
        spaceBetween: 25,
        slideToClickedSlide: true,
        watchSlidesProgress: true,
      });
    }

    const mainEl = this.querySelector('[data-gallery-slider]');

    if (!mainEl) return;

    this.slider = new Swiper(mainEl, {
      slidesPerView: 1,
      spaceBetween: 1,
      zoom: {
        maxRatio: 2,
      },
      navigation: {
        prevEl: this.querySelector('.product-gallery__nav--prev'),
        nextEl: this.querySelector('.product-gallery__nav--next'),
      },
      thumbs: this.thumbsSlider
        ? {
            swiper: this.thumbsSlider,
          }
        : undefined,
    });

    this.slider.on('zoomChange', (swiper, scale) => {
      const zoomed = scale > 1;
      swiper.allowSlideNext = !zoomed;
      swiper.allowSlidePrev = !zoomed;
    });

    const prevBtn = this.querySelector('.product-gallery__nav--prev');
    const nextBtn = this.querySelector('.product-gallery__nav--next');

    const navigateWhileZoomed = (e, direction) => {
      if (!this.slider || this.slider.zoom.scale <= 1) return;
      e.stopPropagation();
      this.slider.zoom.out();
      this.slider.allowSlideNext = true;
      this.slider.allowSlidePrev = true;
      direction === 'next' ? this.slider.slideNext() : this.slider.slidePrev();
    };

    if (prevBtn) {
      prevBtn.addEventListener(
        'click',
        (e) => navigateWhileZoomed(e, 'prev'),
        true,
      );
    }
    if (nextBtn) {
      nextBtn.addEventListener(
        'click',
        (e) => navigateWhileZoomed(e, 'next'),
        true,
      );
    }

    mainEl.addEventListener('click', (e) => {
      if (!this.slider || !this.slider.allowClick) return;
      this.slider.zoom.toggle(e);
    });

    if (this.thumbsSlider) {
      this.thumbsSlider.slides.forEach((slide, index) => {
        slide.addEventListener('click', () => {
          if (this.slider.zoom.scale > 1) {
            this.slider.zoom.out();
            this.slider.allowSlideNext = true;
            this.slider.allowSlidePrev = true;
          }
          this.slider.slideTo(index);
        });
      });
    }
  }

  show(opener) {
    super.show(opener);
    this.initSliders();

    if (this.slider) {
      this.slider.update();

      if (this.thumbsSlider) {
        this.thumbsSlider.update();
      }
    }

    this.showActiveMedia();
  }

  showActiveMedia() {
    if (!this.slider || !this.openedBy) return;

    const activeMediaId = this.openedBy.getAttribute('data-media-id');
    const slides = this.querySelectorAll(
      '[data-gallery-slider] .swiper-slide[data-media-id]',
    );
    let activeIndex = 0;

    slides.forEach((slide, index) => {
      if (slide.getAttribute('data-media-id') === activeMediaId) {
        activeIndex = index;
      }
    });

    this.slider.slideTo(activeIndex, 0);
  }
}

customElements.define('product-modal', ProductModal);
